const Folders = (state) => state.Folders;
const InfoUpload = (state) => state.InfoUpload;
export default { Folders, InfoUpload }